<template>
  <q-btn
    icon="fa fa-times"
    title="Delete Search"
    v-bind="$attrs"
    @click="openModal"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostSearch } from '@/type';
import openModal from '@/components/modal';
import DeleteSearchModal from './DeleteSearchModal.vue';

export default defineComponent({
  emits: ['deleted'],
  props: {
    postSearch: {
      type: Object as () => PostSearch,
      required: true,
    },
  },
  methods: {
    openModal() {
      const props = { postSearch: this.postSearch, parent: this };
      openModal(DeleteSearchModal, props).onOk(() => {
        this.$emit('deleted', this.postSearch);
      });
    },
  },
});
</script>
